<template>
    <div>
        <b-navbar toggleable="lg">
            <b-navbar-brand class="logo" href="#">
                深圳市安博腾生物科技有限公司
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item
                        v-for="(item, idx) in navs"
                        :key="idx"
                        class="nav-item mx-2"
                        :href="item.url"
                        >{{ item.name }}</b-nav-item
                    >
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import navs from "@/config/navs.js";

export default {
    data() {
        return {
            navs
        };
    }
};
</script>

<style lang="less">
@import "./index.less";
</style>
